"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.companyNameOfEmployeeSchema = void 0;
var _zod = require("zod");
var companyNameOfEmployeeSchema = t => {
  var errorMessage = t('payApplication.payapp.memorable.error');
  return _zod.z.object({
    titleEmployee: _zod.z.object({
      displayValue: _zod.z.string().min(1, errorMessage),
      value: _zod.z.string()
    }),
    firstNameEmployee: _zod.z.string().min(2, errorMessage).max(30, errorMessage).regex(/^[A-Za-z\s-]+$/, {
      message: errorMessage
    }),
    lastNameEmployee: _zod.z.string().min(2, errorMessage).max(30, errorMessage).regex(/^[A-Za-z\s-]+$/, {
      message: errorMessage
    })
  });
};
exports.companyNameOfEmployeeSchema = companyNameOfEmployeeSchema;